import { Swiper } from 'swiper';
import {Pagination, Autoplay} from "swiper/modules";
Swiper.use([Pagination, Autoplay]);

export default () => {
    const nodeSelectors = {
        container: '[js-shop-slider="container"]',
        slider: '[js-shop-slider="slider"]',
        pagination: '[js-shop-slider="pagination"]',
        prev: '[js-shop-slider="prev"]',
        next: '[js-shop-slider="next"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let slider = new Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                speed: 500,
                
                pagination: {
                    el: container.querySelector(nodeSelectors.pagination),
                    clickable: true
                },
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                on: {
                    init: function() {
                        handleSlideVideo(this);
                    },
                    slideChange: function() {
                        handleSlideVideo(this);
                    }
                }
            });
            
        })

        function handleSlideVideo(swiper) {

            // Get ALL videos inside this Swiper instance
            const allVideos = swiper.el.querySelectorAll("video");

            // Stop ALL videos in the slider (previous slides)
            allVideos.forEach(video => {
                video.pause();
                video.currentTime = 0; // Reset to start
            });

            // Get active slide
            const activeSlide = swiper.slides[swiper.activeIndex];
            if (!activeSlide) return;

            // Find video INSIDE the active slide
            const video = activeSlide.querySelector("video");
            if (!video) return;

            // Lazy-load: load video only when it becomes active
            if (!video.src && video.dataset.src) {
                video.src = video.dataset.src;
            }

            // Autoplay setup
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.controls = false;

            // Try to play the video
            video.play().catch(err => {
                console.warn("Video autoplay blocked:", err);
            });
        }


        //popup slider
        jQuery(document).ready(function($){

            let gallerySwiper = null; // will hold the Swiper instance

            // Open gallery on click
            $(".single-box-wrap").on("click", function () {

                const popup   = $("#galleryPopup");
                const wrapper = popup.find(".swiper-wrapper");
                const title = popup.find(".popup-overlay .popup-info h3");
                const description = popup.find(".popup-overlay .popup-info p");

                $(".popup-overlay .popup-info h3").text($(this).data('title'));
                $(".popup-overlay .popup-info p").html($(this).data('description'));

                // 1) Clear previous slides
                wrapper.html("");

                // 2) Parse JSON from data-images
                let images = [];
                try {
                    images = JSON.parse($(this).attr("data-images") || "[]");
                } catch (e) {
                    console.error("Invalid JSON in data-images attribute", e);
                }

                // 3) Build slides
                if (images.length > 0) {
                    images.forEach(function(img){
                        wrapper.append(`
                            <div class="swiper-slide">
                                <div class="slide-inner">
                                    <div class="image-holder">
                                        <img src="${img.src}">
                                    </div>
                                </div>
                            </div>
                        `);
                    });
                } else {
                    // Fallback: use images inside the box if no data-images
                    $(this).find("img").each(function(){
                        wrapper.append(`
                            <div class="swiper-slide">
                                <div class="slide-inner">
                                    <div class="image-holder">
                                        <img src="${$(this).attr("src")}" alt="">
                                    </div>
                                </div>
                            </div>
                        `);
                    });
                }

                // 4) If a swiper already exists, destroy it before re-init
                if (gallerySwiper !== null) {
                    gallerySwiper.destroy(true, true);
                    gallerySwiper = null;
                }

                // 5) (Re)initialize Swiper AFTER slides exist
                gallerySwiper = new Swiper("#galleryPopup .myGallerySwiper", {
                    loop: (images.length > 1), // only loop if more than 1 slide
                    navigation: {
                        nextEl: "#galleryPopup .swiper-button-next",
                        prevEl: "#galleryPopup .swiper-button-prev"
                    },
                    pagination: {
                        el: "#galleryPopup .swiper-pagination",
                        clickable: true
                    }
                });

                // 6) Open popup
                popup.fadeIn(200).css('display','flex');
                $('body, html').addClass('gl-no-scroll')
            });

            // Close popup (click on X or dark overlay)
            $(".close-popup, .close-popup .arrow img, .close-popup .arrow, #galleryPopup").on("click", function(e){
                if (e.target !== this) return; // don't close if clicking inside content
                $('body, html').removeClass('gl-no-scroll')
                $("#galleryPopup").fadeOut(200);
            });

        });
    }

    return Object.freeze({
        init,
    })
}